import React, { Fragment, useState } from "react";
import BarcodeScannerComponent from "react-qr-barcode-scanner";
import { DashCircle, Lightbulb, LightbulbOff } from "react-bootstrap-icons";
import "../../Css/QR_Reader.css";
import { Button } from "react-bootstrap";
import { isMobileApp } from "../../store/api/CommonFunctions";

const QR_Reader = (props) => {
  const { popData, setPopData } = props;
  const { onScan, show } = popData;
  const [torchOn, setTorchOn] = useState(false);
  function close() {
    setPopData({ show: false });
  }
  const handleScan = (data) => {
    if (data && data !== null) {
      setPopData({ show: false })
      if (data.includes("\\n")) {
        data = data.split("\\n")[0];
      }
      else if (data.includes("\n")) {
        data = data.split("\n")[0];
      }
      if (data.includes("\r")) {
        data = data.replace("\r", "");
      }
      else if (data.includes("\\r")) {
        data = data.replace("\\r", "");
      }
      if (onScan) {
        onScan(data);
      }
    }
  }
  const handleError = err => {
    console.error("[QR_SCAN_ERROR]", err)
  }
  return (
    <Fragment>
      {show && isMobileApp() &&
        <Fragment>
          <div className="camStyle" style={{ margin: "auto", marginTop: "10px", textAlign:"center" }}>
            <BarcodeScannerComponent
              width={200}
              height={200}
              delay={300}
              torch={torchOn}
              facingMode="environment"
              onError={handleError}
              onUpdate={(err, result) => {
                if (result) {
                  handleScan(result.text);
                }

                else { console.log("Not Found"); }
              }}
            />
          </div>
          <Button variant="danger" style={{ fontSize: "10px", marginTop: "5px" }} onClick={close}><DashCircle size={18} />&nbsp; انصراف</Button>
          <Button variant="warning" style={{ fontSize: "10px", marginTop: "5px", marginRight: "2px" }} onClick={() => setTorchOn(!torchOn)}>{torchOn && <LightbulbOff />}{!torchOn && <Lightbulb />}</Button>
        </Fragment>
      }
    </Fragment>

  )

}
export default QR_Reader;